import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { NetworkStatus } from '@cbridge-utils/network';
import { OrderLifetimeRuleAction } from './orderLifetimeRule.action';
import { orderLifetimeRuleInitialState } from './orderLifetimeRule.constant';

export const orderLifetimeRuleReducer = reducerWithInitialState(orderLifetimeRuleInitialState)
  .case(OrderLifetimeRuleAction.loadList.started, (state) => {
    return {
      ...state,
      networkStatus: NetworkStatus.Started,
    };
  })
  .case(OrderLifetimeRuleAction.loadList.done, (state, payload) => {
    return {
      ...state,
      list: payload.result,
      networkStatus: NetworkStatus.Done,
    };
  })
  .case(OrderLifetimeRuleAction.loadList.failed, (state) => {
    return {
      ...state,
      networkStatus: NetworkStatus.Failed,
    };
  })
  .case(OrderLifetimeRuleAction.destroy, () => ({
    ...orderLifetimeRuleInitialState,
  }));
